import { MenuContext } from "@/contexts/menu/menu";
import { useContext } from "react";

export const useMenu = (): any => {
  return useContext(MenuContext);
};
